import React from 'react'
import { Field } from "./Field";
import { useState } from "react";

import { faAlignJustify, faEdit, faPen, faPlus, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SortableContext, horizontalListSortingStrategy, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { DndContext, KeyboardSensor, PointerSensor, closestCorners, useDroppable, useSensor, useSensors } from "@dnd-kit/core";
import { CSS } from '@dnd-kit/utilities';
import { ContainerFieldField } from './ContainerFieldField';
const rutaImg = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + process.env.REACT_APP_IMAGENES

export const ContainerField = (props) => {
    const { id, index, handleDragEnd, field, indexPadre, handleMostrarModal, removerChildren, anadirHijos, editarChildren } = props;
    const { type, styles } = field;
    const [mostarBotonesField, setMostarBotonesField] = useState(false)


    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id });


    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        width: styles?.width === 0 ? '' : styles?.width ? styles?.width : '100%',
        height: styles?.height === 0 ? '' : styles?.height ? styles?.height : '100%',
        background: (type === 'menuNavegacion') && !styles?.background ? '#000000' : styles?.background,
        backgroundImage: styles.backgroundUrl && `url(${rutaImg + styles.backgroundUrl})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        paddingTop: styles?.paddingArriba,
        paddingBottom: styles?.paddingAbajo,
        paddingLeft: styles?.paddingIzquierda,
        paddingRight: styles?.paddingDerecha,
        marginTop: styles?.marginArriba,
        marginBottom: styles?.marginAbajo,
        marginLeft: styles?.marginIzquierda,
        marginRight: styles?.marginDerecha,
        borderRadius: styles?.borderRadius ? `${styles?.borderRadius}px` : ''
    };


    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );


    return (
        <div ref={setNodeRef} style={style} className={`campo-agregar-container ${styles?.className} ${mostarBotonesField ? 'mostrar-Botones-container' : ''} `} onMouseEnter={() => setMostarBotonesField(true)} onMouseLeave={() => setMostarBotonesField(false)} >
            {mostarBotonesField && (<div className="botones-utiles-container container-field-position">

                <div className="botones-utiles boton-cabecera boton-derecha">
                    <button className="botones-utiles-remover" onClick={() => editarChildren({ id, type, styles })}><FontAwesomeIcon icon={faPen} size="lg" /></button>
                    <button  {...listeners} {...attributes} ><FontAwesomeIcon icon={faAlignJustify} size="lg" /></button>
                    <button className="botones-utiles-remover"><FontAwesomeIcon icon={faPlus} size="lg" onClick={() => anadirHijos(id)} /></button>
                    <button className="botones-utiles-remover"><FontAwesomeIcon icon={faX} size="lg" onClick={() => removerChildren(id)} /></button>
                </div>

            </div>)}
            <DndContext
                sensors={sensors}
                collisionDetection={closestCorners}
                onDragEnd={handleDragEnd}
            >
                <SortableContext
                    id={id}
                    items={field?.fields}
                    strategy={horizontalListSortingStrategy}
                >

                    {field?.fields?.map((f, g) =>
                        <ContainerFieldField editarChildren={editarChildren} handleMostrarModal={handleMostrarModal} id={f.id} field={f} index={index} indexPadre={indexPadre} indexPadreF={g} key={f.id} removerChildren={removerChildren} anadirHijos={anadirHijos} handleDragEnd={handleDragEnd} />
                    )}

                </SortableContext>
            </DndContext>

        </div>
    )
}
